import { render } from "./ItemsView.vue?vue&type=template&id=47cd5318&scoped=true"
import script from "./ItemsView.vue?vue&type=script&lang=js"
export * from "./ItemsView.vue?vue&type=script&lang=js"

import "./ItemsView.vue?vue&type=style&index=0&id=47cd5318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cd5318"]])

export default __exports__